import React from "react";
import TextInput from "../../../core/form/TextInput";

let FacilityFacebookField = ({loading = false}) => {

    return <TextInput
        name='facebook'
        label='form.facility.facebook'
        required={true}
        loading={loading}
    />

}

export default FacilityFacebookField